import { createContext } from 'react';

import { FeatureConfig } from './models/featureFlag';

export const FeatureContext = createContext<FeatureConfig>({});
